var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datepicker',{attrs:{"clear-button":true,"required":true,"disabled-dates":this.disabledDates},on:{"closed":_vm.passDateToParent},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }